import { render, staticRenderFns } from "./LoginCards.vue?vue&type=template&id=2dc0366a&scoped=true&"
import script from "./LoginCards.vue?vue&type=script&lang=js&"
export * from "./LoginCards.vue?vue&type=script&lang=js&"
import style0 from "./LoginCards.vue?vue&type=style&index=0&id=2dc0366a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dc0366a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCol,VIcon,VImg,VRow})
